var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.order)?_c('p',{directives:[{name:"tooltip",rawName:"v-tooltip.top-start",value:({
    content: _vm.tooltipContent,
    boundariesElement: 'body'
  }),expression:"{\n    content: tooltipContent,\n    boundariesElement: 'body'\n  }",modifiers:{"top-start":true}}],staticClass:"vehicle-types m-0",attrs:{"data-test":"vehicle-types"}},[_vm._v(" "+_vm._s(_vm.formattedVehicleTypes)+" ")]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }